import {
  titleUI,
  fullNameUI,
  fullNameSchema,
  ssnUI,
  ssnSchema,
  checkboxUI,
  checkboxSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../../utils/content.json';

export const hasDependentChildToAdd = formData => {
  if (formData?.claimantRelationship === 'SURVIVING_SPOUSE') {
    return formData.dependentUnderYourCare >= 1;
  }
  if (
    formData?.claimantRelationship === 'CUSTODIAN_FILING_FOR_CHILD_UNDER_18'
  ) {
    return formData.dependentUnderYourCare >= 2;
  }
  return formData?.claimantRelationship !== 'SURVIVING_CHILD';
};

const namePage = {
  uiSchema: {
    ...titleUI(
      content['household-dependents-array-child-name-title'],
      'We recommend you list information for a different child than the one you listed as the claimant earlier in the form.',
    ),
    childFullName: fullNameUI(),
    childSocialSecurityNumber: {
      ...ssnUI(),
      'ui:required': formData => !formData?.noSsn,
      'ui:options': {
        hideIf: formData => formData?.noSsn,
      },
    },
    noSsn: checkboxUI({
      title: content['household-dependents-array-child-name-no-ssn'],
    }),
  },
  schema: {
    type: 'object',
    properties: {
      childFullName: fullNameSchema,
      childSocialSecurityNumber: ssnSchema,
      noSsn: checkboxSchema,
    },
    required: ['childFullName'],
  },
};

export default namePage;
